import { Error } from 'store/api/types/error.types';

export enum ApplicationType {
  PSD2 = 'PSD2',
}

export type ApplicationApi = {
  uuid: string;
  name: string;
  enabled: boolean;
  type: string;
  documentionLink: string;
};

export type ApplicationSimple = {
  uuid: string;
};

export type Application = {
  createdAt: string;
  environment: string;
  name: string;
  description: string;
  refId: string | null;
} & ApplicationSimple;

export type ApplicationDetails = Application & {
  clientId: string;
  redirectUris: string[];
  apis: string[];
  qsealcCertificate: boolean;
  qwacCertificate: boolean;
  type: string;
  logoStatus: 'VERIFIED' | 'PENDING' | 'REJECTED' | 'NOT_PROVIDED';
  logoEncoded?: string;
};

export type AddApplicationPayload = {
  name?: string;
  description?: string;
  environment?: string;
  redirectUris?: string[];
  qsealcCertificate?: string;
  qwacCertificate?: string;
  logoEncoded?: string;
  isLogoDeleted?: boolean;
};

export type AddApplicationResponse = {
  payload:
    | ApplicationSimple
    | {
        response: { errors?: Error[] };
        status: number;
      };
  error: boolean;
  type: string;
};

export type UpdateApplicationPayload = AddApplicationPayload;

export type UpdateApplicationResponse = {
  payload: {
    response: {
      errors?: Error[];
      application: Application;
    };
    status: number;
  };
  error: boolean;
  type: string;
};

export type ApplicationDetailsResponse = {
  payload: ApplicationDetails;
  error: boolean;
  type: string;
};

export type RemoveApplicationResponse = {
  payload: {
    response: {
      errors?: Error[];
    };
    status: number;
  };
  error: boolean;
  type: string;
};
